import { render } from "./List.vue?vue&type=template&id=078b1aa2&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=078b1aa2&scoped=true&lang=css"
import "./List.vue?vue&type=style&index=1&id=078b1aa2&lang=less"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078b1aa2"]])

export default __exports__